module.exports = __webpack_public_path__ + "static/media/token-v2-n3d.b1c9159e.png";